<template>
    <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center pt-3">
            <editParameterValueComponent :parameter="mainElement['metros_por_tramo']"
                :value.sync="mainElement['metros_por_tramo'].value"
                :placeholder_titel="mainElement['metros_por_tramo'].attribute.name" :labelOverInput="true"
                :prop_title_show="true" @update:value="refreshParameters">
            </editParameterValueComponent>

            <button @click="removeElement()" style="font-weight:lighter; border-radius: 50%; height:40px; width:40px"
                class="btn btn-outline-secondary ml-2">
                <i class="fas fa-trash-alt"></i>
            </button>
            <!-- @beforeUpdate:value="beforeUpdate"
                @afterUpdate:value="afterUpdate" -->
        </div>
        <div class="card-body row">
            <!-- ERRORES -->
            <div class="col-12" v-if="!b68Helper.isDistanceOk(mainElementIndex)">
                <div class="alert alert-danger" role="alert">
                    {{ b68Helper.getMessage(mainElementIndex) }}
                </div>
            </div>

            <!-- IMAGEN -->
            <div class="col-12 col-sm-6">
                <!-- 70-t_tra  TECHO TRAPECIO-->
                <img style="max-width: 100%; height: auto" v-if="solConstructiva == '70-t_tra'"
                    :src="require('@/assets/images/gamas/68/68-ceiling-trapeze.png')" />

                <!-- 70-t_h_sol TECHO SOPORTE HORIZONTAL -->
                <img style="max-width: 100%; height: auto" v-if="solConstructiva == '70-t_h'"
                    :src="require('@/assets/images/gamas/68/68-ceiling-support-hor.png')" />

                <!-- 70-rack-bottom RACK BOTTOM -->
                <img style="max-width: 100%; height: auto" v-if="solConstructiva == '70-rack-bottom'"
                    :src="require('@/assets/images/gamas/68/68-rack-bottom-center.png')" />

                <!-- 70-rack-h RACK HORIZONTAL -->
                <img style="max-width: 100%; height: auto" v-if="solConstructiva == '70-rack-h'"
                    :src="require('@/assets/images/gamas/68/68-rack-support-hor.png')" />
            </div>

            <!-- PARAMETROS -->
            <div class="col-12 col-sm-6">
                <!-- COMUNES -->
                <editParameterValueComponent :parameter="mainElement['dimensiones']"
                    :value.sync="mainElement['dimensiones'].value"
                    @beforeUpdate:value="b68Helper.beforeUpdateParameter(mainElement, 'dimensiones')"
                    @afterUpdate:value="b68Helper.afterUpdateParameter(mainElement, 'dimensiones')"
                    :placeholder_titel="mainElement['dimensiones'].attribute.name" :labelOverInput="true"
                    :prop_title_show="true" @update:value="refreshParameters">
                </editParameterValueComponent>

                <!-- ESPECIFICOS -->
                <editParameterValueComponent :parameter="mainElement['altura_trabajo']"
                    v-if="solConstructiva == '70-t_tra' || solConstructiva == '70-t_h'"
                    :value.sync="mainElement['altura_trabajo'].value"
                    @beforeUpdate:value="b68Helper.beforeUpdateParameter(mainElement, 'altura_trabajo')"
                    @afterUpdate:value="b68Helper.afterUpdateParameter(mainElement, 'altura_trabajo')"
                    :placeholder_titel="mainElement['altura_trabajo'].attribute.name" :labelOverInput="true"
                    :prop_title_show="true" @update:value="refreshParameters">
                </editParameterValueComponent>

                <editParameterValueComponent :parameter="mainElement['altura_trabajo_rack']"
                    v-if="solConstructiva == '70-rack-bottom' || solConstructiva == '70-rack-h'"
                    :value.sync="mainElement['altura_trabajo_rack'].value"
                    @beforeUpdate:value="b68Helper.beforeUpdateParameter(mainElement, 'altura_trabajo_rack')"
                    @afterUpdate:value="b68Helper.afterUpdateParameter(mainElement, 'altura_trabajo_rack')"
                    :placeholder_titel="mainElement['altura_trabajo_rack'].attribute.name" :labelOverInput="true"
                    :prop_title_show="true" @update:value="refreshParameters">
                </editParameterValueComponent>

                <editParameterValueComponent :parameter="mainElement['distancia_soportes']"
                    :value.sync="mainElement['distancia_soportes'].value"
                    :placeholder_titel="mainElement['distancia_soportes'].attribute.name" :labelOverInput="true"
                    :prop_title_show="true" @update:value="refreshParameters">
                </editParameterValueComponent>
            </div>
        </div>
    </div>
</template>
<script>
import editParameterValueComponent from "./../editParameterValue.vue";
import mainElement68techoTrapecioDiagramaComponent from './mainElement68techoTrapecioDiagrama.vue';
import B68Helper from "../../services/b68helper";
import { app } from "../../application.js";

export default {
    name: 'mainElement68component',

    data() {
        return {
            b68Helper: null
        }
    },

    props: {
        mainElement: {
            type: Object,
            required: true
        },
        mainElementIndex: {
            type: String,
            required: true
        },
        solConstructiva: {
            type: String,
            required: true
        }
    },

    components: {
        editParameterValueComponent,
        mainElement68techoTrapecioDiagramaComponent
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile;
        },
        imgSize() {
            return this.isMobile ? 100 : 200;
        },
        input_width() {
            return this.isMobile ? 100 : 200;
        }
    },
    created() {
        this.b68Helper = new B68Helper(app, this.mainElement);
    },
    methods: {
        refreshParameters() {
            this.$emit('refreshParameters');
        },
        removeElement() {
            this.$emit('removeElement', this.mainElementIndex);
        }
    }
}
</script>